import React, { useState, useEffect } from 'react';
import { bem, classnames, use } from '../../lib';
import { Icon } from '../Icon';
/**
 * Checkbox component
 *
 * @visibleName Checkbox
 */
export const Checkbox = ({ children, className, value = false, disabled = false, color = '075', onChange = () => { } }) => {
    const [checked, setChecked] = useState(value);
    useEffect(() => {
        checked !== value;
        setChecked(value);
    }, [value]);
    const clsName = classnames(className, bem('checkbox', use(checked, '--checked')));
    function handleChange() {
        setChecked(!checked);
        onChange(!checked);
    }
    return (React.createElement("div", { className: 'checkbox__wrapper', onClick: disabled ? undefined : handleChange },
        React.createElement("div", { className: clsName },
            React.createElement("input", { disabled: disabled, className: 'checkbox__input', type: 'checkbox', checked: checked, onChange: handleChange }),
            checked && React.createElement(Icon, { name: 'check', className: 'checkbox__check' })),
        children ? React.createElement("div", { className: 'checkbox__label' }, children) : null));
};
//# sourceMappingURL=Checkbox.js.map